import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Clock, 
  Bell, 
  Timer, 
  Radio, 
  Youtube, 
  Globe, 
  Heart,
  Shield,
  FileText,
  ArrowUp
} from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative mt-16 bg-gradient-to-t from-blue-900/80 to-blue-800/60 backdrop-blur-md border-t border-blue-600/30">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Website Logo & Features */}
          <div>
            <Link 
              to="/" 
              className="text-white font-semibold text-lg mb-4 flex items-center gap-2 hover:text-cyan-400 transition-colors"
            >
              <img 
                src="/logo.png" 
                alt="Clock Online Logo" 
                className="h-8" 
                style={{width: 'auto'}}
              />
              Clock Online
            </Link>
            <ul className="space-y-3 mt-4">
              <li>
                <Link 
                  to="/" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Bell className="w-4 h-4" />
                  Home / Alarms
                </Link>
              </li>
              <li>
                <Link 
                  to="/world-clock" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Globe className="w-4 h-4" />
                  World Clock
                </Link>
              </li>
              <li>
                <Link 
                  to="/timers" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Timer className="w-4 h-4" />
                  Timers
                </Link>
              </li>
              <li>
                <Link 
                  to="/meditation" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Heart className="w-4 h-4" />
                  Meditation
                </Link>
              </li>
            </ul>
          </div>

          {/* Advanced Features */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 flex items-center gap-2">
              <Radio className="w-5 h-5 text-cyan-400" />
              Advanced
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/radio-alarm" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Radio className="w-4 h-4" />
                  Radio Alarm
                </Link>
              </li>
              <li>
                <Link 
                  to="/video-alarm" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Youtube className="w-4 h-4" />
                  Video Alarm
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 flex items-center gap-2">
              <Shield className="w-5 h-5 text-cyan-400" />
              Legal
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/privacy-policy" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <Shield className="w-4 h-4" />
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link 
                  to="/terms-of-service" 
                  className="text-white/70 hover:text-cyan-400 transition-colors flex items-center gap-2"
                >
                  <FileText className="w-4 h-4" />
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-blue-600/30 mt-6 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            
            {/* Copyright */}
            <div className="flex items-center gap-2">
              <Clock className="w-6 h-6 text-cyan-400" />
              <div className="text-white/70">
                <p className="text-sm">
                  © {currentYear} Clock Online. All rights reserved.
                </p>
              </div>
            </div>

            {/* Back to Top Button */}
            <button
              onClick={scrollToTop}
              className="flex items-center gap-2 px-4 py-2 bg-cyan-600/20 hover:bg-cyan-600/30 
                         text-cyan-400 hover:text-cyan-300 rounded-lg transition-all duration-200
                         border border-cyan-600/30 hover:border-cyan-500/50"
            >
              <ArrowUp className="w-4 h-4" />
              <span className="text-sm font-medium">Back to Top</span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}